import { Component, Input } from "@angular/core";
import { CardLoaderSize } from "../card-types";

@Component({
  selector: "card-loader",
  templateUrl: "./card-loader.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: contents; }"],
})
export class CardLoaderComponent {
  @Input() size: CardLoaderSize = CardLoaderSize.Large;
  cardLoaderSize = CardLoaderSize;
}
